import React, { Component } from "react";
import Moment from "moment";
import {
  MomentDateFormat,
  getStatusIcon,
  getStatusIconByDueDate,
  getDateStatusColor,
  TimelineItemDateText,
  CheckIfNotActive,
  IsOpenDescript,
} from "./CustomFuntion";
import { Timeline, TimelineItem } from "vertical-timeline-component-for-react";
import Collapsible from "react-collapsible";
import "../../styles/timelineItem.css";
import "../../styles/timeline.css";

import { Link } from "office-ui-fabric-react";
import CheckboxComp from "../checkboxComponent";
import { EventEmitter } from "../events";

interface IState {
  currentItems: any;
  upcomingItems: any;
  overdueItems: any;
  currentDate: Date;
  currentText: string;
  overdueText: string;
  upcomingText: string;
  documentURL: string;
  activeTaskIsOpen: boolean;
  overdueTaskIsOpen: boolean;
  upcomingTaskIsOpen: boolean;
}

class ActiveTask extends Component<{}, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      currentDate: new Date(),
      currentItems: [],
      upcomingItems: [],
      overdueItems: [],
      currentText: "Current(Month)",
      upcomingText: "Upcoming",
      overdueText: "Overdue",
      documentURL: "",
      activeTaskIsOpen: true,
      overdueTaskIsOpen: false,
      upcomingTaskIsOpen: false,
    };
      EventEmitter.subscribe('onMarkCompleted', (event: any) => {
          this.onMarkCompleted(event);
      });      
  }

  componentDidMount() {
    this.getAPI().then((apiRes: any) => {
      let api = JSON.parse(apiRes);
      this.setState(
        {
          documentURL: api.matterdetail,
        },
        () => {
          this._generateOverdueItem(this.props.items);
          this._generateUpcoming(this.props.items);
          this._generateCurrent(this.props.items);
        },
      );
    });
  }

  getAPI() {
    return new Promise((resolve) => {
      resolve(localStorage.getItem("api"));
    });
    }

    onMarkCompleted = (event: any) => {
        var current = this.state.currentItems;
        var overdue = this.state.overdueItems;
        var upcoming = this.state.upcomingItems;

        for (var x = 0; x < current.length; x++) {
            if (current[x].id == event) {
                current.splice(x, 1);
                break;
			}
        }
        for (var x = 0; x < overdue.length; x++) {
            if (overdue[x].id == event) {
                overdue.splice(x, 1);
                break;
            }
        }
        for (var x = 0; x < upcoming.length; x++) {
            if (upcoming[x].id == event) {
                upcoming.splice(x, 1);
                break;
            }
        }

        this.setState({
            currentItems: current,
            overdueItems: overdue,
            upcomingItems: upcoming
        });
       

        
  }

  _generateCurrent(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = MomentDateFormat(currItem[c].data.event.dueDate);
      if (
        parseInt(itemDate.format("YYYYMM").toString()) ==
          parseInt(
            Moment(this.state.currentDate).format("YYYYMM").toString(),
          ) &&
        CheckIfNotActive(currItem[c].data.event.status) &&
        currItem[c].data.event.status !== "Complete"
      ) {
        tempUpcoming.push(currItem[c]);
      }
    }
    this.setState({
      currentItems: tempUpcoming,
    });
  }

    _generateUpcoming(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = MomentDateFormat(currItem[c].data.event.dueDate);
      if (
        parseInt(itemDate.format("YYYYMM").toString()) >
          parseInt(
            Moment(this.state.currentDate).format("YYYYMM").toString(),
          ) &&
        CheckIfNotActive(currItem[c].data.event.status)
      ) {
        tempUpcoming.push(currItem[c]);
      }
    }
    this.setState({
      upcomingItems: tempUpcoming,
    });
  }

  _generateOverdueItem(currItem: any) {
    let tempOverdue = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = MomentDateFormat(currItem[c].data.event.dueDate);
      if (
        parseInt(itemDate.format("YYYYMM").toString()) <
          parseInt(
            Moment(this.state.currentDate).format("YYYYMM").toString(),
          ) &&
        CheckIfNotActive(currItem[c].data.event.status)
      ) {
        tempOverdue.push(currItem[c]);
      }
    }
    this.setState({
      overdueItems: tempOverdue,
    });
  }
  generateCurrentItems() {
    this.state.currentItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.currentItems.map((items: any) => {
      return (
        <TimelineItem
          key={items.id}
          dateText={TimelineItemDateText(items.data.event.dueDate)}
          dateInnerStyle={{
            background: getDateStatusColor(items.data.event.dueDate),
          }}
          style={{ color: getStatusIconByDueDate(items.data.event.dueDate) }}
        >

          <Collapsible
            key={items.id}
            className={"Collapsible-TimeLineItem"}
            trigger={items.data.event.task}
            open={IsOpenDescript(items.data.event.dueDate)}
           >
           <CheckboxComp key={items.id} data={items}/>       
            <Link
              type="submit"
              href={
                this.state.documentURL +
                "/Matter?matterCode=" +
                items.data.matterCode +
                "#/Workflow"
              }
              target="_blank"
            >
              {items.data.matterCode}
            </Link>
            {` - ${items.data.description}`}
            <hr className="line-item" />
            {items.data.event.assignTo.length > 0 ? (
              <b className="assignToLabel">{"AssignTo: "} </b>
            ) : (
              ""
            )}
            {items.data.event.assignTo.map((assignto: any, index: any) => {
              return <i key={items.id + index}>{assignto.name}, </i>;
            })}
          </Collapsible>
        </TimelineItem>
      );
    });
  }

  generateUpcomingItems() {
    this.state.upcomingItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });

    return this.state.upcomingItems.map((items: any) => {
      return (
        <TimelineItem
          key={items.id}
          dateText={TimelineItemDateText(items.data.event.dueDate)}
          dateInnerStyle={{
            background: getDateStatusColor(items.data.event.dueDate),
          }}
          style={{ color: getStatusIcon(items.data.event.status) }}
        >
          <Collapsible
            key={items.id}
            className={"Collapsible-TimeLineItem"}
            trigger={items.data.event.task}>
            <CheckboxComp key= {items.id} data={items}/>      
            <Link
              type="submit"
              href={
                this.state.documentURL +
                "/Matter?matterCode=" +
                items.data.matterCode +
                "#/Workflow"
              }
              target="_blank"
            >
              {items.data.matterCode}
            </Link>
            {` - ${items.data.description}`}
            <hr className="line-item" />
            {items.data.event.assignTo.length > 0 ? (
              <b className="assignToLabel">{"AssignTo: "} </b>
            ) : (
              ""
            )}
            {items.data.event.assignTo.map((assignto: any, index: any) => {
              return <i key={items.id + index}>{assignto.name}, </i>;
            })}
          </Collapsible>
        </TimelineItem>
      );
    });
  }
  generateOverDueItems() {
    this.state.overdueItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.overdueItems.map((items: any) => {
      return (
        <TimelineItem
          key={items.id}
          dateText={TimelineItemDateText(items.data.event.dueDate)}
          dateInnerStyle={{
            background: getDateStatusColor(items.data.event.dueDate),
          }}
          style={{ color: "red" }}
        >
          <Collapsible
            key={items.id}
            className={"Collapsible-TimeLineItem"}
            trigger={items.data.event.task}>
            <CheckboxComp key={items.id} data={items} />
            <Link
              type="submit"
              href={
                this.state.documentURL +
                "/Matter?matterCode=" +
                items.data.matterCode +
                "#/Workflow"
              }
              target="_blank"
            >
              {items.data.matterCode}
            </Link>
            {` - ${items.data.description}`}
            <hr className="line-item" />
            {items.data.event.assignTo.length > 0 ? (
              <b className="assignToLabel">{"AssignTo: "} </b>
            ) : (
              ""
            )}
            {items.data.event.assignTo.map((assignto: any, index: any) => {
              return <i key={items.id + index}>{assignto.name}, </i>;
            })}
          </Collapsible>
        </TimelineItem>
      );
    });
  }
  TaskHideShow(status: boolean, staters: string) {
    if (staters === "active") this.setState({ activeTaskIsOpen: status });
    if (staters === "upcoming") this.setState({ upcomingTaskIsOpen: status });
    if (staters === "overdue") this.setState({ overdueTaskIsOpen: status });
  }

  public render() {
    return (
      <div className={"active-task-v-line ms-motion-slideDownIn"}>
        <Timeline
          key="TL-Overdue"
          id="overdue"
          lineColor={"#ddd"}
          animations={true}
          className={`${
            this.state.overdueTaskIsOpen && this.state.overdueItems.length
              ? ""
              : "empty"
          }`}
        >
          <Collapsible
            key="Cls-Overdue"
            id="overdue"
            className="overdue-text"
            triggerOpenedClassName="overdue-text-span"
            trigger={
              this.state.overdueText +
              "  (" +
              this.state.overdueItems.length +
              ")"
            }
            open={false}
            triggerDisabled={false}
            onOpen={() => this.TaskHideShow(true, "overdue")}
            onClose={() => this.TaskHideShow(false, "overdue")}
          >
            {this.generateOverDueItems()}
          </Collapsible>
        </Timeline>
        <Timeline
          key="TL-Active"
          id="activetask"
          lineColor={"#ddd"}
          animations={true}
          className={`${
            this.state.activeTaskIsOpen && this.state.currentItems.length
              ? ""
              : "empty"
          }`}
        >
          <Collapsible
            key="Cls-Active"
            id="activetask"
            className="current-text current-text-span"
            triggerOpenedClassName="current-text-span"
            trigger={
              Moment(this.state.currentDate).format("MMMM").toString() +
              "  (" +
              this.state.currentItems.length +
              ")"
            }
            open={true}
            triggerDisabled={false}
            onOpen={() => this.TaskHideShow(true, "active")}
            onClose={() => this.TaskHideShow(false, "active")}
          >
            {this.generateCurrentItems()}
          </Collapsible>
        </Timeline>
        <Timeline
          key="TL-Upcoming"
          id="upcoming"
          lineColor={"#ddd"}
          animations={true}
          className={`${
            this.state.upcomingTaskIsOpen && this.state.upcomingItems.length
              ? ""
              : "empty"
          }`}
        >
          <Collapsible
            key="Cls-Upcoming"
            id="upcoming"
            className="upcoming-text"
            triggerOpenedClassName="upcoming-text-span"
            trigger={
              this.state.upcomingText +
              "  (" +
              this.state.upcomingItems.length +
              ")"
            }
            open={false}
            triggerDisabled={false}
            onOpen={() => this.TaskHideShow(true, "upcoming")}
            onClose={() => this.TaskHideShow(false, "upcoming")}
          >
            {this.generateUpcomingItems()}
          </Collapsible>
        </Timeline>
      </div>
    );
  }
}

export default ActiveTask;
